import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("lemonade_token");
    if (!token) {
      setUser(null);
      setOrganization(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOrganization(data.organization);
    } catch {
      localStorage.removeItem("lemonade_token");
      setUser(null);
      setOrganization(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("lemonade_token", data.token);
    setUser(data.user);
    setOrganization(data.organization);
    return data;
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("lemonade_token", data.token);
    setUser(data.user);
    setOrganization(data.organization);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("lemonade_token");
    setUser(null);
    setOrganization(null);
  };

  const setSessionFromAuth = (data) => {
    if (!data) return;
    if (data.token) localStorage.setItem("lemonade_token", data.token);
    if (data.user) setUser(data.user);
    if (data.organization) setOrganization(data.organization);
  };

  return (
    <AuthCtx.Provider value={{ user, organization, loading, login, signup, logout, refresh, setSessionFromAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
